import { render, staticRenderFns } from "./PpeApplyScrapEdit.vue?vue&type=template&id=687f87b8&"
import script from "./PpeApplyScrapEdit.vue?vue&type=script&lang=js&"
export * from "./PpeApplyScrapEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports